import { isArray, isEmptyObject, isObject } from "./validators";

interface Obj {
  [props: string]: any;
}

// tslint:disable-next-line: cyclomatic-complexity
export function removeEmptyValues<T extends Obj>(obj: T): T {
  const normalized: any = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === "string" && value.trim().length === 0) {
        continue;
      } else if (isArray(value) && value.length === 0) {
        continue;
      } else if (isObject(value) && isEmptyObject(value)) {
        continue;
      } else {
        normalized[key] = typeof value === "string" ? value.trim() : value;
      }
    }
  }

  return normalized as T;
}
